exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".block-video[data-v-39293274] {\n  width: 100%;\n  position: relative;\n  z-index: 0;\n}\n.block-video[data-v-39293274]::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #f6f6f6;\n  z-index: -1;\n}\n.block-video .block-video__title[data-v-39293274] {\n  text-align: center;\n}\n.block-video .block-video__video-wrapper[data-v-39293274] {\n  max-width: 679px;\n  width: 100%;\n}", ""]);

// exports
